import { fetch } from '../'

export default {
  async getAll () {
    let response = await fetch(`/wp-json/wpvue/v1/options/${window.lang ? '?lang=' + window.lang : ''}`)
    let data = await response.json()
    return response.ok ? data : {}
  }
}
